import { render, staticRenderFns } from "./ProjectAddNew.vue?vue&type=template&id=7c3e5999&"
import script from "./ProjectAddNew.vue?vue&type=script&lang=js&"
export * from "./ProjectAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports